<template>
	<div v-bind:centered="centered" :class="$style.container" :style="{ background: $report.color($finder.avg(data))}">
		<ProjectHistoryGaugeChart :width="87" :height="60" :data="data"/>
	</div>
</template>

<style lang="scss" module rel="stylesheet/scss">
	.container {
		width: 100%;
		box-sizing: border-box;
		height: 64px;
		position: relative;
		&[centered='true'] {
			margin: auto;
		}
		&:after {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			box-sizing: border-box;
			border: 1px solid rgba(#fff, .6);
		}
	}
</style>

<script>
	import ProjectHistoryGaugeChart from '../../charts/ProjectHistoryGauge';

	export default {
		props: {
			data: Array,
			centered: Boolean
		},
		components: {
			ProjectHistoryGaugeChart
		},
	}
</script>
